/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import './Policies.css';

const EmailLink = <a href="mailto:info@stakmobility.com">info@stakmobility.com</a>;
const StakUrl = (
  <a target="_blank" rel="noreferrer" href="https://www.stakmobility.com">
    https://www.stakmobility.com
  </a>
);
const PrivacyHereLink = <a href="/privacy-policy">here</a>;
const AAAUrl = (
  <a target="_blank" rel="noreferrer" href="http://www.adr.org">
    www.adr.org
  </a>
);

export default function TermsOfUseContent() {
  return (
    <div className="policy">
      <h1>Terms of Service</h1>
      <p>Last Modified: May 2026</p>

      <div className="policy-section">
        <h2>I. Acceptance of the Terms of Service</h2>
        <p>
          The following Terms of Service, together with any documents incorporated by reference
          (&ldquo;<b>Terms</b>&rdquo;), govern your access to and use of the website located at {StakUrl}, and its
          microsites, mobile websites, mobile applications, and any other related software owned and
          operated by Stak Corp. (&ldquo;<b>Company</b>,&rdquo; &ldquo;<b>we</b>,&rdquo; &ldquo;<b>our</b>,&rdquo; or &ldquo;<b>us</b>&rdquo;), as well
          as, any of our services, including without limitation, our physical electric vehicle charging
          equipment, vehicle parking solutions, and car fleet management services (collectively, the
          &ldquo;<b>Services</b>&rdquo;).
        </p>
        <blockquote>
          <p>
            Please read these Terms of Service carefully before you start to use the Services.{' '}
            <b>
              By using the Services, you accept and agree to be bound and abide by these Terms of
              Service and our Privacy Policy, found {PrivacyHereLink}, incorporated herein by reference.
            </b>{' '}
            If you do not agree to these Terms of Service or the Privacy Policy, you must not access or
            use the Services.
          </p>
        </blockquote>
        <p>
          <b>
            <u>
              YOUR USE OF THE SERVICES ARE SUBJECT TO AN ARBITRATION PROVISION IN SECTION 11,
              REQUIRING ANY CLAIM OR DISPUTE WITH COMPANY TO BE RESOLVED BY WAY OF BINDING
              ARBITRATION. BY AGREEING TO THESE TERMS, YOU AND COMPANY WAIVE ANY RIGHT TO PARTICIPATE
              IN A CLASS-ACTION LAWSUIT OR CLASS-WIDE ARBITRATION.
            </u>
          </b>
        </p>
      </div>

      <div className="policy-section">
        <h2>II. Changes to the Terms of Service</h2>
        <p>
          We may revise and update these Terms of Service from time to time in our sole discretion. All
          changes are effective immediately when we post them, and apply to all access to and use of the
          Services thereafter.
        </p>
        <p>
          Your continued use of the Services following the posting of revised Terms of Service or
          Privacy Policy means that you accept and agree to the changes. You are expected to check this
          page each time you access or use the Services so you are aware of any changes, as they are
          binding on you.
        </p>
      </div>

      <div className="policy-section">
        <h2>III. Accessing the Services</h2>
        <p>We reserve the right to withdraw or amend the Services in our sole discretion without notice.</p>
        <p>
          We will not be liable if, for any reason all, the Services are unavailable at any time or for
          any period. From time to time, we may restrict access to some of the Services, or to certain
          users, including registered users.
        </p>
        <p>
          To access the Services or some of the resources they offer, you may be asked to provide
          certain registration details or other information. It is a condition of your use of the
          Services that all the information you provide is correct, current and complete. You agree
          that all information you provide to register through the Services is governed by our Privacy
          Policy, and you consent to all actions we take with respect to your information consistent
          with our Privacy Policy.
        </p>
        <p>
          If you choose, or are provided with, a user name, password or any other piece of information
          as part of our security procedures, you must treat such information as confidential, and you
          must not disclose it to any other person or entity. You also acknowledge that your account is
          personal to you and agree not to provide any other person with access to the Services or
          portions of it using your user name, password or other security information. You agree to
          notify us immediately of any unauthorized access to or use of your user name or password or
          any other breach of security. You also agree to ensure that you exit from your account at the
          end of each session. You should use particular caution when accessing your account from a
          public or shared computer so that others are not able to view or record your password or
          other personal information.
        </p>
        <p>
          We have the right to disable any user name, password or other identifier, whether chosen by
          you or provided by us, at any time in our sole discretion for any or no reason, including if,
          in our opinion, you have violated any provision of these Terms of Service.
        </p>
        <p>
          <b>
            YOU ARE SOLELY RESPONSIBLE FOR ANY ITEMS, PROPERTY, OR INDIVIDUALS LEFT IN OR AROUND YOUR
            VEHICLE WHILE USING THE SERVICES. THE COMPANY SHALL NOT BE RESPONSIBLE OR LIABLE FOR ANY
            LOSS, THEFT, DAMAGE, INJURY, OR HARM RELATING TO ANY PERSONAL PROPERTY OR BELONGINGS LEFT
            IN A VEHICLE, INCLUDING WITHOUT LIMITATION ELECTRONICS, CASH, WALLETS, PURSES, LUGGAGE,
            PACKAGES, DOCUMENTS, CLOTHING, OR OTHER VALUABLES, NOR SHALL THE COMPANY BE RESPONSIBLE FOR
            ANY PETS, CHILDREN, PASSENGERS, OR OTHER INDIVIDUALS LEFT UNATTENDED IN OR AROUND A VEHICLE
            WHILE USING THE SERVICES.
          </b>
        </p>
      </div>

      <div className="policy-section">
        <h2>IV. Intellectual Property Rights</h2>
        <p>
          The Services, and all information, software, text, trademarks, logos, displays, images, video
          and audio, designs, and arrangements in, on, or related to those Services, are owned by the
          Company, its licensors or other providers of such material and are protected by United States
          and international copyright, trademark, patent, trade secret and other intellectual property
          or proprietary rights laws. These Terms of Service permit you to use the Services for your
          personal, non-commercial use only. You must not copy, mirror, frame, reproduce, distribute,
          modify, create derivative works of, translate, publicly display, publicly perform, republish,
          download, store or transmit any of the material on our Services, in whole or in part, or in
          any way without our prior written consent, except as follows:
        </p>
        <ul>
          <li>
            Your computer may temporarily store copies of such materials in RAM incidental to your
            accessing and viewing those materials.
          </li>
          <li>
            You may store files that are automatically cached by your Web browser for display
            enhancement purposes.
          </li>
          <li>
            You may print or download one copy of a reasonable number of pages of the website for your
            own personal, non-commercial use and not for further reproduction, publication or
            distribution.
          </li>
          <li>
            If we provide desktop, mobile or other applications for download, you may download a single
            copy to your computer or mobile device solely for your own personal, non-commercial use,
            provided you agree to be bound by our end user license agreement for such applications.
          </li>
          <li>
            If we provide social media features with certain content, you may take such actions as are
            enabled by such features.
          </li>
        </ul>
        <div>
          <blockquote>
            <p>
              <b>You must not</b>:
            </p>
          </blockquote>
          <ul>
            <li>Modify copies of any materials within the Services.</li>
            <li>
              Use any illustrations, photographs, video or audio sequences or any graphics separately
              from the accompanying text.
            </li>
            <li>
              Delete or alter any copyright, trademark or other proprietary rights notices from
              copies of materials from within the Services.
            </li>
          </ul>
        </div>
        <p>You must not access or use for any commercial purposes any part of the Services.</p>
        <p>
          If you wish to use any material available through the Services in a manner not expressly
          permitted under this section, please submit your request to: {EmailLink}.
        </p>
        <p>
          If you print, copy, modify, download or otherwise use or provide any other person with access
          to any part of the Services in breach of the Terms of Service, your right to use the Services
          will cease immediately and you must, at our option, return or destroy any copies of the
          materials you have made. No right, title or interest in or to the Services or any content
          therein is transferred to you, and all rights not expressly granted are reserved by the
          Company. Any use of the Services not expressly permitted by these Terms of Service is a
          breach of these Terms of Service and may violate copyright, trademark and other laws.
        </p>
        <h3>Trademarks</h3>
        <p>
          Our Company name, our logo, and all related names, logos, product and service names, designs
          and slogans are trademarks of the Company or its affiliates or licensors. You must not use
          such marks without the prior written permission of the Company. All other names, logos,
          product and service names, designs and slogans encountered through the Services are the
          trademarks of their respective owners.
        </p>
      </div>

      <div className="policy-section">
        <h2>V. Prohibited Uses</h2>
        <p>
          You agree not to access or use the Services for any unlawful purpose or in violation of these
          Terms of Service, including without limitation, to:
        </p>
        <ol type="a">
          <li value="1">
            transmit any information or message that contains unlawful, infringing, threatening,
            fraudulent, libelous, defamatory, obscene or abusive information or language;
          </li>
          <li value="2">
            falsify or delete any author attributions, legal or other proper notices or proprietary
            designations or labels of the origin or source of software or other material contained in a
            file that is uploaded;
          </li>
          <li value="3">
            falsely state or misrepresent your affiliation with any person or entity, including the
            origin of any information you provide;
          </li>
          <li value="4">
            reproduce, duplicate, copy, download, store, further transmit, disseminate, distribute,
            transfer, or otherwise exploit the Services, or any portion thereof without the prior
            written consent of Company, except as expressly permitted herein, and is not used or shared
            in any way that is commercially prejudicial to or competitive with Company;
          </li>
          <li value="5">
            violate any applicable federal, state, local or international law or regulation (including,
            without limitation, any laws regarding the export of data or software to and from the US
            or other countries);
          </li>
          <li value="6">
            send, knowingly receive, upload, download, use or re-use any material which does not comply
            with these Terms of Service;
          </li>
          <li value="7">
            transmit, or procure the sending of, any advertising or promotional material without our
            prior written consent, including any &ldquo;junk mail&rdquo;, &ldquo;chain letter&rdquo; or &ldquo;spam&rdquo; or any other
            similar solicitation;
          </li>
          <li value="8">
            impersonate or attempt to impersonate the Company, a Company employee, another user or any
            other person or entity (including, without limitation, by using e-mail addresses or screen
            names associated with any of the foregoing);
          </li>
          <li value="9">
            engage in any other conduct that restricts or inhibits anyone&rsquo;s use or enjoyment of the
            Services, or which, as determined by us, may harm the Company or users of the Services or
            expose them to liability;
          </li>
        </ol>
        <blockquote>
          <p>
            Additionally, <b>you agree not to</b>:
          </p>
        </blockquote>
        <ol start="10" type="a">
          <li value="10">
            use the Services in any manner that could disable, overburden, damage, or impair the
            Services interfere with any other party&rsquo;s use of the Services, including their ability to
            engage in real time activities through the Services;
          </li>
          <li value="11">
            use any robot, spider, intelligent agent, or other automatic device, process or means to
            search, monitor, or copy the Services, or the reports, data, information, content,
            software, products, services, or other materials thereon, generated by or obtained through
            the Services or any other unauthorized means to compile or access the Services for any
            purpose without Company&rsquo;s permission, with the exception of generally available third-party
            web browsers;
          </li>
          <li value="12">
            use any device, software or routine that interferes with the proper working of the
            Services, or attempt to probe, scan, test the vulnerability of, or breach the security of
            the Company system or network;
          </li>
          <li value="13">
            introduce any viruses, trojan horses, worms, logic bombs or other material which is
            malicious or technologically harmful;
          </li>
          <li value="14">
            attempt to gain unauthorized access to, overburden, interfere with, damage or disrupt any
            parts of the Services, the server on which the website portion of the Services is stored,
            or any server, computer or database connected to the that website;
          </li>
          <li value="15">
            attack the website portion of the Services via a denial-of-service attack or a distributed
            denial-of-service attack;
          </li>
          <li value="16">
            otherwise attempt to interfere with the proper working of the website or any other portion
            of the Services; or
          </li>
          <li value="17">
            interfere with or attempt to interfere with any software making up a part of the Services,
            by way of circumvention, reverse engineering, deciphering, decompiling disassembling,
            decrypting, or otherwise.
          </li>
        </ol>
        <p>
          YOU ALSO AGREE NOT TO ENGAGE IN ANY RECKLESS BEHAVIOR WHILE USING OR ACCESSING THE SERVICES,
          INCLUDING WITHOUT LIMITATION, WHILE UNDER THE INFLUENCE OF ALCOHOL, DRUGS, SUBSTANCE, OR ANY
          OTHER CONDITIONS THAT WOULD REASONABLY POSE A HARM TO THE SAFETY OF YOURSELF OR OTHERS. YOU
          ACKNOWLEDGE AND AGREE THAT STAK CORP. IS NOT RESPONSIBLE FOR YOUR CONDUCT WHILE USING OR
          ACCESSING THE SERVICES AND YOUR FAILURE TO COMPLY WITH THESE TERMS OF SERVICE IS AT YOUR OWN
          RISK AND THAT STAK CORP SHALL HAVE NO LIABILITY ARISING FROM YOUR FAILURE TO COMPLY WITH
          THESE TERMS OF SERVICE.
        </p>
        <p>
          Violation of system or network security and certain other conduct may result in civil or
          criminal liability. We may investigate and work with law enforcement authorities to prosecute
          users who violate these Terms of Service. We may suspend or terminate your access to the
          Services for any or no reason at any time without notice.
        </p>
      </div>

      <div className="policy-section">
        <h2>VI. Changes to the Services</h2>
        <p>
          We may update the content of the Services from time to time, but its content is not
          necessarily complete or up-to-date. Any of the material on the Services may be out of date at
          any given time, and we are under no obligation to update such material.
        </p>
      </div>

      <div className="policy-section">
        <h2>VII. Information About You and Interactions with the Services</h2>
        <p>
          All information we collect about you through the Services is subject to our Privacy Policy.
          By using the Services, you consent to all actions taken by us with respect to your
          information in compliance with the Privacy Policy.
        </p>
      </div>

      <div className="policy-section">
        <h2>VIII. Other Terms and Condition</h2>
        <blockquote>
          <p>
            Additional terms and conditions may also apply to specific portions of the Services,
            including without limitation, the SaaS Services Agreement (the &ldquo;SAAS Agreement&rdquo;). All such
            additional terms and conditions are hereby incorporated by this reference into these Terms
            of Service, as applicable. In the event of a conflict between these Terms of Service and
            the SAAS Agreement, the latter shall govern.
          </p>
        </blockquote>
      </div>

      <div className="policy-section">
        <h2>IX. Linking to the Website and Social Media Features</h2>
        <p>
          You may link to our website portion of our Services, provided you do so in a way that is fair
          and legal and does not damage our reputation or take advantage of it, but you must not
          establish a link in such a way as to suggest any form of association, approval or endorsement
          on our part.
        </p>
        <p>The website may provide certain social media features that enable you to:</p>
        <ul>
          <li>Link from your own or certain third-party websites to certain content on the website.</li>
          <li>
            Send e-mails or other communications with certain content, or links to certain content, on
            the website.
          </li>
          <li>
            Cause limited portions of content on this website to be displayed or appear to be displayed
            on your own or certain third-party websites.
          </li>
        </ul>
        <p>
          You may use these features solely as they are provided by us and solely with respect to the
          content they are displayed with and otherwise in accordance with any additional terms and
          conditions we provide with respect to such features. Subject to the foregoing, you must not:
        </p>
        <ul>
          <li>Establish a link from any website that is not owned by you.</li>
          <li>
            Cause the website or portions of it to be displayed, or appear to be displayed by, for
            example, framing, deep linking or in-line linking, on any other site.
          </li>
          <li>Link to any part of the website other than the homepage.</li>
          <li>
            Otherwise take any action with respect to the materials on the website that is inconsistent
            with any other provision of these Terms of Service.
          </li>
        </ul>
        <p>
          You agree to cooperate with us in causing any unauthorized framing or linking immediately to
          cease. We reserve the right to withdraw linking permission without notice.
        </p>
        <p>
          We may disable all or any social media features and any links at any time without notice in
          our discretion.
        </p>
      </div>

      <div className="policy-section">
        <h2>X. Third-Party Providers &amp; Links</h2>
        <blockquote>
          <p>
            Certain aspects of the Services may overlap with third-party service providers, including
            without limitation, contractors, vendors, property owners, parking operators, valet
            personnel, towing companies, maintenance personnel, vehicle charging station operators,
            payment processors, security personnel, or other third parties (collectively,
            &ldquo;Third-Party Providers&rdquo;). Such Third-Party Providers are independent entities and are not
            employees, agents, partners, joint venturers, or representatives of the Company unless
            expressly stated otherwise.
          </p>
          <p>
            The Company does not control and is not responsible or liable for the acts, omissions,
            conduct, negligence, errors, services, or policies of any Third-Party Providers, including
            without limitation, any damage to vehicles, loss of property, delays, towing,
            parking-related incidents, personal injury, theft, misconduct, or other acts or omissions
            caused by or attributable to any Third-Party Providers. Your interactions with any
            Third-Party Providers are undertaken at your own risk.
          </p>
        </blockquote>
        <p>
          The Services may also contain links to other websites and online resources belonging to
          third-parties. These links are provided for your convenience only. We have no control over
          the contents of those third-party websites or resources, and accept no responsibility for
          them or for any loss or damage that may arise from your use of them. If you decide to access
          any of the third-party websites linked from the Services, you do so entirely at your own risk
          and subject to the terms and conditions of use of that third-party.
        </p>
      </div>

      <div className="policy-section">
        <h2>XI. Geographic Restrictions</h2>
        <p>
          The Services are for use only by persons located in the United States. We make no claims that
          the Services are accessible or appropriate outside of the United States. Access to the
          Services may not be legal by certain persons or in certain countries. If you access the
          Services from outside the United States, you do so on your own initiative and are responsible
          for compliance with local laws.
        </p>
      </div>

      <div className="policy-section">
        <h2>XII. Force Majeure</h2>
        <p>
          Company shall not be liable or responsible for any failure, interruption, delay, defect, or
          inability to provide the Services resulting from events or circumstances beyond its
          reasonable control, including without limitation acts of God, severe weather, natural
          disasters, fire, flood, pandemics, public health emergencies, war, terrorism, civil unrest,
          labor disputes, governmental actions, changes in laws or regulations, utility or power
          outages, internet or telecommunications failures, cyberattacks, electric grid or charging
          infrastructure failures, transportation disruptions, and shortages of labor or materials
          (each, a &ldquo;Force Majeure Event&rdquo;). During any Force Majeure Event, Company may suspend, limit,
          modify, or discontinue all or any portion of the Services without liability, and Company
          shall not be responsible for any loss, damage, injury, delay, theft, vehicle-related issue,
          charging interruption, or other damages arising out of or relating to such Force Majeure
          Event.
        </p>
      </div>

      <div className="policy-section">
        <h2>XIII. Disclaimer of Warranties</h2>
        <blockquote>
          <p>
            YOUR USE OF THE SERVICES IS AT YOUR OWN RISK. THE SERVICES ARE PROVIDED ON AN &ldquo;AS IS&rdquo; AND
            &ldquo;AS AVAILABLE&rdquo; BASIS, WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. NEITHER
            THE COMPANY NOR ANY PERSON OR ENTITY ASSOCIATED WITH THE COMPANY MAKES ANY WARRANTY OR
            REPRESENTATION REGARDING THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY,
            SAFETY, TIMELINESS, OR AVAILABILITY OF THE SERVICES.
          </p>
          <p>
            WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR ANY PERSON OR ENTITY ASSOCIATED
            WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE SERVICES WILL BE ACCURATE, RELIABLE,
            ERROR-FREE, SAFE, OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT THE SERVICES OR
            THE SYSTEMS THAT SUPPORT THEM WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT
            THE SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
          </p>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY DISCLAIMS ALL RESPONSIBILITY AND
            LIABILITY ARISING FROM OR RELATED TO YOUR USE OF THE SERVICES, INCLUDING WITHOUT
            LIMITATION, ANY DAMAGE TO PROPERTY, INCLUDING VEHICLES, THEFT, VANDALISM, TOWING, LOSS OF
            PERSONAL PROPERTY, CHARGING FAILURES, PARKING-RELATED INCIDENTS, ACCIDENTS, COLLISIONS,
            BODILY INJURY, PERSONAL INJURY, DEATH, OR ANY OTHER LOSS OR DAMAGE THAT MAY OCCUR IN
            CONNECTION WITH THE USE OF THE SERVICES OR ANY LOCATION AT WHICH THE SERVICES ARE PROVIDED.
          </p>
          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND,
            WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING WITHOUT LIMITATION WARRANTIES
            OF MERCHANTABILITY, NON-INFRINGEMENT, FITNESS FOR A PARTICULAR PURPOSE, TITLE, SECURITY,
            COURSE OF DEALING, COURSE OF PERFORMANCE, AND USAGE OF TRADE.
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER
            APPLICABLE LAW.
          </p>
        </blockquote>
      </div>

      <div className="policy-section">
        <h2>XIV. Limitation on Liability</h2>
        <blockquote>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL COMPANY&rsquo;S AGGREGATE
            AND TOTAL LIABILITY HEREUNDER EXCEED THE AMOUNT OF FEES PAID TO COMPANY DURING THE SIX (6)
            MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM.
          </p>
          <p>
            IN NO EVENT WILL COMPANY BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL,
            EXEMPLARY, OR PUNITIVE DAMAGES, PERSONAL INJURY, BODILY INJURY, WRONGFUL DEATH, EMOTIONAL
            DISTRESS, PROPERTY DAMAGE, VEHICLE DAMAGE, THEFT, VANDALISM, LOSS OF PERSONAL PROPERTY,
            LOSS OF DATA, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OPPORTUNITIES, LOSS OF
            GOODWILL, LOSS OF USE, OR ANY OTHER TANGIBLE OR INTANGIBLE LOSS ARISING OUT OF OR RELATING
            TO THE SERVICES, INCLUDING WITHOUT LIMITATION ANY INCIDENTS INVOLVING VEHICLES, PARKING
            FACILITIES, ELECTRIC VEHICLE CHARGING EQUIPMENT, VALET SERVICES, THIRD-PARTY PROVIDERS, OR
            OTHER USERS OF THE SERVICES.
          </p>
          <p>
            WITHOUT LIMITING THE FOREGOING, COMPANY SHALL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED
            BY SERVICE INTERRUPTIONS, SYSTEM FAILURES, PAYMENT FAILURES, CYBERATTACKS, VIRUSES,
            UNAUTHORIZED ACCESS, THEFT, NEGLIGENCE OF THIRD PARTIES, OR ANY FAILURE, DELAY, ERROR,
            OMISSION, INTERRUPTION, OR DEFECT IN THE OPERATION OF THE SERVICES.
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED UNDER
            APPLICABLE LAW.
          </p>
        </blockquote>
      </div>

      <div className="policy-section">
        <h2>XV. Indemnification</h2>
        <p>
          You agree to defend, indemnify and hold harmless the Company, its affiliates, licensors and
          service providers, and its and their respective officers, directors, employees, contractors,
          agents, licensors, suppliers, successors and assigns from and against any claims,
          liabilities, damages, judgments, awards, losses, costs, expenses or fees (including
          reasonable attorneys&rsquo; fees) arising out of or relating to your violation of these Terms of
          Service or your use or interaction with the Services other than as expressly authorized in
          these Terms of Service or your use of any information obtained from the Services.
        </p>
      </div>

      <div className="policy-section">
        <h2>XVI. Mandatory Arbitration of Dispute and Class Action Waiver</h2>
        <blockquote>
          <p>
            All matters relating to the Services, and/or these Terms of Service, and any dispute or
            claim arising therefrom or related thereto (in each case, including non-contractual
            disputes or claims), shall be governed by and construed in accordance with the laws of the
            State of New York without giving effect to any choice or conflict of law provision or rule
            (whether of the State of New York or any other jurisdiction).
          </p>
          <p>
            Any legal suit, action, or proceeding arising out of, or related to, these Terms of Service
            shall be instituted exclusively through binding arbitration under the Rules of Arbitration
            of the American Arbitration Association (&ldquo;AAA&rdquo;) applying New York law in New York County,
            New York. ARBITRATION MEANS THAT YOU WAIVE YOUR RIGHT TO A JUDGE OR JURY IN A COURT
            PROCEEDING AND YOUR GROUNDS FOR APPEAL ARE LIMITED.
          </p>
          <p>
            In the event of a dispute, you must first send to Company, a notice of the dispute that
            shall include a written statement that sets forth the name, address and all relevant
            contact information, the facts giving rise to the dispute, and the relief requested (the
            &ldquo;Dispute Notice&rdquo;). The Dispute Notice must be addressed to Stak Corp. 431 10
            <sup>th</sup> Street, Brooklyn, New York 11215, Attn: Legal. If you and Company do not reach
            an agreement to resolve the dispute within sixty (60) days after the Dispute Notice is
            received, either party may commence an arbitration proceeding pursuant to this Section.
            Following submission and receipt of the Dispute Notice, each party agrees to act in good
            faith to seek to resolve the dispute before commencing arbitration.
          </p>
        </blockquote>
      </div>

      <div className="policy-section">
        <h2>XVII. Class Action Waiver</h2>
        <blockquote>
          <p>
            YOU EXPRESSLY WAIVE ANY ABILITY TO MAINTAIN ANY CLASS ACTION IN ANY FORUM. ANY ARBITRATION,
            CLAIM, OR OTHER PROCEEDINGS BETWEEN YOU AND COMPANY SHALL BE CONDUCTED ON AN INDIVIDUAL
            BASIS AND NOT IN ANY CLASS ACTION, MASS ACTION, OR ON A CONSOLIDATED OR REPRESENTATIVE
            BASIS. NEITHER PARTY WILL SEEK TO HAVE ANY DISPUTE HEARD AS A CLASS ACTION, PRIVATE
            ATTORNEY GENERAL ACTION, OR IN ANY OTHER PROCEEDING IN WHICH EITHER PARTY ACTS OR PROPOSES
            TO ACT IN A REPRESENTATIVE CAPACITY. NO ARBITRATION OR OTHER PROCEEDING WILL BE COMBINED
            WITH ANOTHER WITHOUT THE PRIOR WRITTEN CONSENT OF ALL PARTIES TO ALL AFFECTED ARBITRATIONS
            OR PROCEEDINGS.
          </p>
        </blockquote>
      </div>

      <div className="policy-section">
        <h2>XVIII. Arbitration Procedure</h2>
        <blockquote>
          <p>
            The arbitration will be administered by the AAA and governed by the Consumer Arbitration
            Rules of the AAA (&ldquo;AAA Rules&rdquo;) in conjunction with the rules set forth in these Terms of
            Service, except that AAA may not administer any multiple claimant or class arbitration, as
            the parties agree that the arbitration shall be limited to the resolution only of
            individual claims. The AAA Rules are at {AAAUrl}. If there is a conflict between the AAA
            Rules and these Terms of Service, these Terms of Service shall govern. The arbitrator is
            bound by these Terms of Service. The arbitrator, and not any federal, state, or local court
            or agency, shall have exclusive authority to resolve all disputes arising out of or
            relating to the interpretation, applicability, enforceability or formation of these Terms
            of Service, including, but not limited to, any claim that all or part of these Terms of
            Service is void or voidable. The arbitrator&rsquo;s award shall be binding on the parties and may
            be entered as a judgment in any court of competent jurisdiction.
          </p>
        </blockquote>
      </div>

      <div className="policy-section">
        <h2>XIX. Limitation on Time to File Claims</h2>
        <p>
          ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO THESE TERMS OF
          SERVICE OR THE SERVICES MUST BE COMMENCED WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION
          ACCRUES, OTHERWISE, SUCH CAUSE OF ACTION OR CLAIM IS PERMANENTLY BARRED.
        </p>
      </div>

      <div className="policy-section">
        <h2>XX. Waiver and Severability</h2>
        <p>
          No waiver by the Company of any term or condition set forth in these Terms of Service shall
          be deemed a further or continuing waiver of such term or condition or a waiver of any other
          term or condition, and any failure of the Company to assert a right or provision under these
          Terms of Service shall not constitute a waiver of such right or provision.
        </p>
        <p>
          If any provision of these Terms of Service is held by a court or other tribunal of competent
          jurisdiction to be invalid, illegal or unenforceable for any reason, such provision shall be
          eliminated or limited to the minimum extent such that the remaining provisions of the Terms
          of Service will continue in full force and effect.
        </p>
      </div>

      <div className="policy-section">
        <h2>XXI. Entire Agreement</h2>
        <p>
          The Terms of Service, our Privacy Policy and any applicable SAAS, or subscription agreement
          constitute the sole and entire agreement between you and Stak Corp. with respect to the
          Services and supersede all prior and contemporaneous understandings, agreements,
          representations and warranties, both written and oral, with respect to the Services.
        </p>
      </div>

      <div className="policy-section">
        <h2>XXII. Your Comments and Concerns</h2>
        <p>
          All feedback, comments, requests for technical support, claims, and other communications
          relating to the Services should be directed to: {EmailLink}.
        </p>
      </div>
    </div>
  );
}
